module.exports = "<div class=\"banner slide-banner\">\n    <nz-carousel [nzAutoPlay]=\"false\">\n        <div class=\"banner-list\" nz-carousel-content *ngFor=\"let imgItem of imgData\">\n            <img class=\"img im\" src=\"{{imgItem.imgUrl}}\">\n        </div>\n    </nz-carousel>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/topdetail/slide.component.html
// module id = 1157
// module chunks = 73